export default __webpack_public_path__ + "static/media/pen-only-disabled.0258c274.svg";